export class StartCampaignRequestApiModel {
    campaignID: number;
    customerList: Array<string>;
    sendToAll: boolean;
    scheduledStartDate: string;
}